export default "__VITE_ASSET__5PV_8iok__"